<template>
    <div id="Error" class="err-hide text-center" v-bind:class="{'err-show':error!==''}">
        <p class="rounded white bg-red-6">{{error}}</p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed:{
        ...mapGetters(['error'])
    }
}
</script>

<style lang='scss'>
.err-hide{
    position: fixed;
    bottom: -4rem;left: 0;right: 0;
    margin: 0 auto;
    min-width: 12rem;
    max-width: 24rem;
    z-index: 100;opacity: 0;
    transition: all 0.5s ease;
    p{padding: 0.4rem 2rem;}
}
.err-show{
    opacity: 1;
    bottom: 2rem;
}
</style>
